import axios from "axios";
import compose from "compose-function";
import { promiseSnakeToCamelCaseObject } from "./Utility";
let getAllJobCodes = () => axios
    .get("/sl3/api/jobcodes", { params: { start: 1, end: 9999 } })
    .then(({ data }) => data)
    .then(({ data }) => data);
getAllJobCodes = compose(promiseSnakeToCamelCaseObject, getAllJobCodes);
export { getAllJobCodes };
